import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
      result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn(this, result);
  };
}
function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}
import React from 'react';
import { Modal, Button, Icon } from 'semantic-ui-react';
import { LocationPropType } from '../../../services/proptypes';
import CustomerReview from '../CustomerReview/CustomerReview';
import './CustomerReviewModal.css';
var defaultProps = {
  locations: [],
  showRating: true
};
var CustomerReviewModal = /*#__PURE__*/function (_React$Component) {
  _inherits(CustomerReviewModal, _React$Component);
  var _super = _createSuper(CustomerReviewModal);
  function CustomerReviewModal(props) {
    var _this;
    _classCallCheck(this, CustomerReviewModal);
    _this = _super.call(this, props);
    _this.state = {
      open: false
    };
    return _this;
  }
  _createClass(CustomerReviewModal, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props = this.props,
        businessId = _this$props.businessId,
        locations = _this$props.locations,
        showRating = _this$props.showRating,
        businessType = _this$props.businessType;
      var open = this.state.open;
      return /*#__PURE__*/React.createElement(Modal, {
        onClose: function onClose() {
          return _this2.setState({
            open: false
          });
        },
        onOpen: function onOpen() {
          return _this2.setState({
            open: true
          });
        },
        open: open,
        dimmer: "inverted",
        className: "submit-reviews-modal",
        closeOnDimmerClick: false,
        trigger: /*#__PURE__*/React.createElement("div", {
          className: "submit-review-button-container"
        }, /*#__PURE__*/React.createElement(Button, {
          primary: true
        }, "Submit Review")),
        size: "small"
      }, /*#__PURE__*/React.createElement(Modal.Header, null, /*#__PURE__*/React.createElement("div", null, "Write a Review"), /*#__PURE__*/React.createElement(Icon, {
        name: "close",
        onClick: function onClick() {
          _this2.setState({
            open: false
          });
        }
      })), /*#__PURE__*/React.createElement(Modal.Content, null, /*#__PURE__*/React.createElement(CustomerReview, {
        businessId: businessId,
        businessType: businessType,
        locations: locations,
        showRating: showRating
      })));
    }
  }]);
  return CustomerReviewModal;
}(React.Component);
export { CustomerReviewModal as default };
CustomerReviewModal.defaultProps = defaultProps;